module.exports = __webpack_public_path__ + "img/2022-6.a29df991.png";